import React from 'react'
import {RadioGroup as RadioGroupUI, FormHelperText, Typography, withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import GridBlock from 'components/GridBlock';
import Tr from 'translations/Translations';
import SimpleTable from 'components/complex/simpleTable/SimpleTable';
import getObjectValue from 'libs/getObjectValue';
import clsx from "clsx";
import RadioGroupElement from "./RadioGroupElement";


const style = theme => ({
    root: {
        marginBottom: theme.spacing(2)
    },
    textBold: {
        fontWeight: theme.typography.fontWeightBold,
        marginBottom: theme.spacing()
    },
    samllColumn: theme.components.table.lpColumn,
    orderColumn: theme.components.table.ipColumn,
    checkboxColumn: {
        width: theme.spacing(),
        paddingTop: 0,
        paddingBottom: 0
    },
    nameColumn: {
        paddingTop: theme.spacing(),
        paddingBottom: theme.spacing(),
    },
    checkbox: {
        padding: 0,
    },
    cursor: {
        cursor: "pointer"
    }
})

function PartsRadioTable(
    {
        classes,
        className,
        formikProps,
        id,
        elementList = [],
        label,
        orderLabel = "part_number",
        editable = true,
        required = true,
        disabled
    }) {
    const value = getObjectValue(id, formikProps.values, null);
    const errorValue = getObjectValue(id, formikProps.errors, '');
    const touched = getObjectValue(id, formikProps.touched, false);

    const isError = editable && !!errorValue && Boolean(touched);
    const helperText = errorValue || ' ';
    const hasOrder = !!(elementList?.[0]?.order);
    return (
        <GridBlock
            className={clsx(classes.root, className)}
            column
        >
            <Typography
                variant='body1'
                className={classes.textBold}
            >
                {label ? label : Tr('assign_to_part')}{required ? '*' : ''}
            </Typography>
            <RadioGroupUI
                name={id}
                onChange={(event) => {
                    formikProps.handleChange(event);
                }}
                onBlur={formikProps.handleBlur}
                value={value}
            >
                <SimpleTable
                    headers={[
                        undefined,
                        (hasOrder ? Tr(orderLabel) : Tr('column_lp')),
                        Tr('name')
                    ]}
                    items={elementList.map((x, i) => {
                        return [
                            <RadioGroupElement
                                htmlId={`${id}.${x.identity}`}
                                key={i}
                                value={x.value}
                                disabled={!editable || disabled}
                            />,
                            <label className={classes.cursor} htmlFor={`${id}.${x.identity}`}>{!!x.order ? x.order : i + 1}</label>,
                            <label className={classes.cursor} htmlFor={`${id}.${x.identity}`}>{x.name}</label>,
                        ]
                    })}
                    columnClasses={[
                        classes.checkboxColumn,
                        hasOrder ? classes.orderColumn : classes.samllColumn,
                        classes.nameColumn
                    ]}
                />
            </RadioGroupUI>
            {isError && <FormHelperText error>{helperText}</FormHelperText>}
        </GridBlock>
    )
}

PartsRadioTable.propTypes = {
    classes: PropTypes.any,
}

export default withStyles(style)(PartsRadioTable);
